import { render, staticRenderFns } from "./RxMessageBox.vue?vue&type=template&id=2f4d5e53"
import script from "./RxMessageBox.vue?vue&type=script&lang=js"
export * from "./RxMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports